import { render } from "./MiniQuiz.vue?vue&type=template&id=682fc6e3&scoped=true"
import script from "./MiniQuiz.vue?vue&type=script&lang=js"
export * from "./MiniQuiz.vue?vue&type=script&lang=js"

import "../assets/css/MiniQuiz.css?vue&type=style&index=0&lang=css&external"
import "./MiniQuiz.vue?vue&type=style&index=1&id=682fc6e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682fc6e3"]])

export default __exports__